import Inspector from './inspector';
const { InnerBlocks } = wp.blockEditor;

export default function Edit({ attributes, setAttributes }) {
  const { tabsHeading, margin } = attributes;

  return (
    <div className={`tab-section ${margin}`}>
      <Inspector attributes={attributes} setAttributes={setAttributes} />

      {!tabsHeading.length < 0 && (
        <h2>Por favor, registre uma guia pelo inspetor</h2>
      )}

      {tabsHeading.length > 0 && (
        <>
          <div className="Tab Container">
            {tabsHeading.map((heading) => {
              if (!heading.title) return null;

              return (
                <button
                  id={heading.tabId}
                  className="tablinks pagetab"
                  data-url-id={heading.urlId}
                >
                  {heading.title}
                </button>
              );
            })}
          </div>

          <div>
            <InnerBlocks
              template={[['app/tab']]}
              allowedBlocks={[['app/tab']]}
              renderAppender={InnerBlocks.DefaultBlockAppender}
            />
          </div>
        </>
      )}
    </div>
  );
}
